import type { FaireProductEntity } from "../../entity_types/product";

export const p_amdb42yyjx: FaireProductEntity = {
  token: "p_amdb42yyjx",
  type: "product",
  name: "Vortex Sun 18K Gold Plated Stainless Steel Ring - FGS/MS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/519ad2460ddaa9bb501132ce3eb18afbc4014fa9992121849c1f26360435d00f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/66d5af811f892e6d0e27ec8254721e9b07ed27ae09e1171a3c18d354c01c101d.jpeg",
    "https://cdn.faire.com/fastly/03fd2f0ee53fada71964bbd89a5b89d03ee3384de4a1f9ad46e589715fc8e61a.jpeg",
    "https://cdn.faire.com/fastly/570467b82c89d50d69e9cefa159765839dd9043c5a74075fb561796f01da6a12.jpeg",
  ],
  priceDollars: 5.49,
  description:
    "\nType: Ring\nMaterial : Stainless steel ,18K gold plated\nSize : 7#\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts ",
  tags: [],
  msrpDollars: 10.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:09.482Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
